class SessionStorage {
  static announcement_status = 'announcement_status';

  static getAnnouncementNotificationStatus = () => {
    return window.sessionStorage.getItem(SessionStorage.announcement_status);
  };

  static setSeenAnnouncementNotification = () => {
    window.sessionStorage.setItem(SessionStorage.announcement_status, 'seen');
  };
}

export default SessionStorage;
